var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"talkPage"},[_c('Top'),_c('div',{staticClass:"container"},[_c('router-view',{staticClass:"contents"})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }